module.exports = __webpack_public_path__ + "img/parkeren.0a6068bc.png";